
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.396 5.452V9.39h-.97V5.452H.7v-.909h3.726V.605h.97v3.938h3.726v.91H5.396zm5.763-1.415v-.91h8.422v.91H11.16zm0 2.837v-.91h8.422v.91H11.16z","fill":"currentColor"}})])
          )
        }
      }
    